declare namespace $ {

	type $shm_date_view__value_shm_period_1 = $mol_type_enforce<
		ReturnType< $shm_period['date_from'] >
		,
		ReturnType< $shm_date_view['value'] >
	>
	type $shm_date_view__value_shm_period_2 = $mol_type_enforce<
		ReturnType< $shm_period['date_to'] >
		,
		ReturnType< $shm_date_view['value'] >
	>
	export class $shm_period extends $mol_view {
		date_from( next?: string ): string
		Date_from( ): $shm_date_view
		date_to( next?: string ): string
		Date_to( ): $shm_date_view
		sub( ): readonly(any)[]
		period_str( next?: string ): string
		period( next?: ({ 
			'from': string,
			'to': string,
		})  ): ({ 
			'from': string,
			'to': string,
		}) 
		clear( ): any
	}
	
}

//# sourceMappingURL=period.view.tree.d.ts.map